// combatpro/panels/monsters/studio/MonsterStudioToast.js
//
// Combat PRO - MonsterStudioToast (Stage 58: Persistence & Cloud CRUD).
//
// A minimal transient message strip (#vi-st-toast), the equivalent of the legacy
// viStudioToast feedback used after save / delete / archive / version actions. It is
// driven entirely by a runtime message id: each new messageId re-shows the strip
// and starts an auto-hide timer. It renders text only and owns no application state.
// The element id defaults to vi-st-toast; an optional id prop lets a second instance
// (e.g. import feedback) mount without colliding. No DOM access, no localStorage. No
// optional chaining. No em dash.

import React, { useState, useEffect } from 'react';

function MonsterStudioToast(props) {
  const [visible, setVisible] = useState(false);

  var messageId = props.messageId;
  useEffect(function() {
    if (!messageId) { return undefined; }
    setVisible(true);
    var t = setTimeout(function() { setVisible(false); }, 2600);
    return function() { clearTimeout(t); };
  }, [messageId]);

  if (!visible || !props.message) { return null; }

  return (
    <div className="vi-st-toast" id={props.id || 'vi-st-toast'} role="status">
      {props.message}
    </div>
  );
}

export default MonsterStudioToast;
